module.exports = transferArrayToObject([
  /*************************** ⭐ 先放这里（关键修复） **************************** */
  {
    context: ['/yxh-pub'],
    target: 'http://bi-dmp-cs.yiigle.com:9091',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/yxh-pub': ''
    }
  },
  /*************************** 中控台 **************************** */
  {
    context: ['/zkt/', '/org/'],
    target: 'http://magazine-yxhzkt.testx.fzyun.io',
    // target: 'http://magazine-portal.testx.fzyun.io', //测试环境
    // target: 'https://journal.devx.fzyun.io',
    changeOrigin: true,
    secure: false
  },
  /*************************** 数智中心 **************************** */
  {
    context: ['/bi-api/'],
    target: 'https://uatwk.yiigle.com',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/bi-api/': '/baas-api/'
    }
  },
  /*************************** increment-service **************************** */
  // {
  //   context: ['/das-api/'],
  //   target: 'http://www.das.testx.fzyun.io', // 增值服务测试环境
  //   // target: 'http://www.das.publish.founderss.cn', //正式环境
  //   changeOrigin: true,
  //   secure: false
  // },
  {
    context: ['/das-manager/', '/das-web-c/', '/das-asis/', '/das-api/'],
    target: 'http://www.das.testx.fzyun.io', // 增值服务测试环境
    // target: 'http://www.das.publish.founderss.cn',
    changeOrigin: true,
    secure: false
  },
  {
    context: ['/yxh-das-asis', '/yxh-das-web-c'],
    target: 'https://uatwk.yiigle.com/',
    changeOrigin: true,
    secure: false
  },
  {
    context: ['/yxh-das-api/'],
    target: 'http://bi-dmp-cs.yiigle.com:8083',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/yxh-das-api': ''
    }
  },

  /*************************** publish-center **************************** */
  {
    context: ['/rc-pub/'],
    target: 'http://pub.publish.testx.fzyun.io',
    // target: 'https://pub.publish.devx.fzyun.io', // 公司开发环境
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/rc-pub': ''
    }
  },

  {
    context: ['/maas-pub-manager/'],
    target: 'http://magazine-pub-manager.publish.testx.fzyun.io',
    // target: 'http://magazine-pub-manager.publish.devx.fzyun.io',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/maas-pub-manager': ''
    }
  },
  {
    context: ['/magazine-pub-third/'],
    target: 'https://uatwk.yiigle.com/',
    // target: 'http://magazine-pub-manager.publish.devx.fzyun.io',
    changeOrigin: true,
    secure: false
  },

  /*************************** 影响力监控 **************************** */
  {
    context: ['/statistics/pub/'],
    target: 'http://pub.publish.testx.fzyun.io',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/statistics/pub': ''
    }
  },
  {
    context: ['/statistics/edit/', '/statistics/product/'],
    target: 'https://journal.testx.fzyun.io',
    changeOrigin: true,
    secure: false
  },

  /*************************** 会议中心 **************************** */
  {
    context: ['/rc-meeting/'],
    target: 'http://meeting-api.testx.fzyun.io',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/rc-meeting': ''
    }
  },

  /*************************** portal **************************** */
  {
    context: ['/portal/'],
    target: 'http://magazine-portal.testx.fzyun.io', //测试环境
    // target: 'http://magazine-portal.devx.fzyun.io', // 开发环境
    // target: 'https://journal.portal.founderss.cn/', // 正式环境
    changeOrigin: true,
    secure: false
  },

  /*************************** resource **************************** */
  {
    context: ['/rc-api/', '/journal-web/'],
    target: 'http://rc-api.publish.testx.fzyun.io',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/rc-api': ''
    }
  },

  /*************************** editing **************************** */
  {
    context: ['/je-api/'],
    target: 'http://web-mag-edit.testx.fzyun.io',
    // target: 'http://web-mag-edit.devx.fzyun.io', // 公司开发环境
    changeOrigin: true,
    secure: false
  },

  /*************************** product **************************** */
  {
    context: [
      '/magazine/',
      '/work/',
      '/article/',
      '/book/',
      '/common/',
      '/index/',
      '/userCenter/',
      '/upload/',
      '/importArticle/',
      '/resource/',
      '/comparisonversion/',
      '/newUI/',
      '/huibian/',
      '/tache/',
      '/rc-production/'
    ],
    target: 'https://prerelease.testx.fzyun.io',
    // target: 'https://prerelease.devx.fzyun.io', // 公司开发环境
    changeOrigin: true,
    headers: {
      host: 'prerelease.testx.fzyun.io'
    },
    secure: false
  },

  /*************************** Platform Operation **************************** */
  {
    context: [
      '/group',
      '/org/',
      '/magazine/',
      '/magazineMessage/',
      '/magazineMessageOther/',
      '/baas-api/'
    ],
    target: 'http://magazine-manager.testx.fzyun.io',
    // target: 'http://magazine-manager.devx.fzyun.io',
    // target: 'https://journal.portal.founderss.cn/',
    changeOrigin: true,
    secure: false
  },

  /*************************** 业务中台 **************************** */
  {
    context: ['/baas-api', '/template-key', '/template/'],
    target: 'https://baas-gateway.testx.fzyun.cn/',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/baas-api': ''
    }
  },

  /*************************** 大数据中心 **************************** */
  {
    context: [
      '/adcs-api/',
      '/adcs-api/api/',
      '/adcs-api/api/article/',
      '/adcs-api/api/org/',
      '/org/',
      '/api/' // ⚠️ 保留，但已经不会抢 yxh-pub 了
    ],
    // target: 'http://magazine-manager.testx.fzyun.io',
    target: 'http://magazine-manager.devx.fzyun.io',
    changeOrigin: true,
    secure: false,
    pathRewrite: {
      '^/adcs-api': ''
    }
  }
])

function transferArrayToObject(rules) {
  return rules.reduce((pre, cur) => {
    if (!Array.isArray(cur.context)) {
      throw new Error(`${JSON.stringify(cur)} 中的 context 不是数组！`)
    }

    const _context = Array.prototype.slice.call(cur.context)
    delete cur.context

    _context.forEach((apiPath) => {
      pre[apiPath] = {
        ...cur
      }
    })

    return pre
  }, {})
}
